const React =              require("react");

const DataActionUtil = require("../../util/DataActionUtil.js");
const ApplicationContext = require("../../config/ApplicationContext.js");
const ImportUtil =        require("../../util/ImportUtil.js");
const UploadFileButton   = require("../buttons/generic/UploadFileButton.jsx");
 
class ImportLibraries extends React.Component {

    constructor(){
        super();

        this.modelImported = this.modelImported.bind(this);
        this.handleImportUrl = this.handleImportUrl.bind(this);
        this.handleImportFile = this.handleImportFile.bind(this);
    }


    handleImportFile(files){
        let file = files[0]
        let {onUpload, idHub, handleError, setLoading} = this.props;

        if(onUpload)
            onUpload(`Uploading library '${file.name}'`);
        
        if(ImportUtil.validateFile(file)) {
            googleGA("send", "event", "library", "upload");
            ImportUtil.createLibrary(handleError, "file", file, {hub: idHub})
                .then((createdLibrary) => {
                    this.modelImported(createdLibrary);
                })
                .catch(() => {
                    handleError(null, 'upload this file', `Please check that ${file.name} is a valid library.  Accepts formats lbr, intlib, pcblib, schlib, and olb.`)
                    setLoading(false)
                })
        }else{
            handleError(null, 'upload this file', `Please check that ${file.name} is a valid library.  Accepts formats lbr, intlib, pcblib, schlib, and olb.`)
            setLoading(false)
        }
    }

    handleImportUrl(){
        var val = this.formText.value.trim();
        if(!ImportUtil.validateUrl(val)) { 
            this.props.setLoading(false)
            this.props.handleError(null, 'upload this file', 'Please check that this is a valid library URL.')
            return;
        }
        this.props.onUpload(`Uploading library '${val}'`);
        
        googleGA("send", "event", "library", "uploadurl");
        ImportUtil.createLibrary(this.props.handleError, "url", val, {hub: this.props.idHub})
            .then((createdLibrary) => {
                this.modelImported(createdLibrary);
            })
            .catch(error => {
                    this.props.setLoading(false)
                    this.props.handleError(null, 'upload this file', 'Please check that this is a valid library URL.')
                    this.formText.value = "";
                }
            )
    }

    modelImported(createdLibrary) {
        this.formText.value = "";
        ApplicationContext.onLibraryChange(1);
        this.props.onComplete();
        // Export library after version is imported. Export is needed in order to get children data (searching libraries by component names)
        DataActionUtil.exportLibraryAfterImport(() => {}, createdLibrary);
    }

    render() {
        return  <section className="import-library">
                    <h1 className="import-library__title">Import Library</h1>
                    <div className="form__inline import-library__form">
                        <UploadFileButton
                            accept=".lbr,.intlib,.pcblib,.schlib,.olb"
                            onUpload={this.handleImportFile}
                            text="Upload File"
                        /> OR 
                        <input type="text" placeholder="Enter URL to Library" className="form__text" 
                            ref={input => this.formText = input} />
                        <button className="button" onClick={this.handleImportUrl}><p>Import</p></button>
                    </div>
                    <div className="import-library__description">
                        Import .lbr, Altium Designer® and CircuitStudio® (*.SchLib, *.PcbLib, *.IntLib) or
                        OrCAD Capture® (*.olb) libraries
                    </div>
                </section>
    }
};

module.exports = ImportLibraries;
